<template>
  <div v-if="hotzone" class="hotzone-wrap">
    <img
      :src="hotzone.images[hotzone.current || 0].image"
      :style="`height: ${hotzone.images[hotzone.current || 0].imageHeight}rpx`"
    />
    <div
      v-for="(item, index) in hotzone.list"
      :key="index"
      :style="`width: ${item.width};height: ${item.height};top: ${item.top};left: ${
        item.left
      };z-index: ${item.zIndex || 1};`"
      class="area"
      @click="haddleClick(item, index)"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'hotzoneComponent',
  props: {
    eventName: {
      type: String,
      default: ''
    },
    pageId: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: {
        list: []
      }
    }
  },
  data() {
    return {
      hotzone: null
    }
  },
  watch: {
    data: {
      handler(res) {
        const hotzone = res
        const { image, images, list } = hotzone
        const moduleWidth = 750

        let imageList =
          images && !!images.length
            ? images
            : image
            ? [{ image: hotzone.image, image_radio: hotzone.image_radio }]
            : []

        imageList.map(item => {
          if (Number(item.image_radio)) {
            item.imageHeight = moduleWidth / item.image_radio
          }
        })

        hotzone.images = imageList

        list.map(v => {
          v.width = this.getStyle(v.widthPer)
          v.height = this.getStyle(v.heightPer)
          v.top = this.getStyle(v.topPer)
          v.left = this.getStyle(v.leftPer)
        })

        this.hotzone = hotzone
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  methods: {
    haddleClick(item, index) {
      const { name, action } = item

      const { open_mode, page, query } = action
      if (open_mode == 4 && page) {
        this.$api.find.getGenerateUrl({ page, query, type: 2 }).then(res => {
          const url = (res.data && res.data.data && res.data.data.link) || ''
          window.location.href = url
        })
      }

      gio('track', 'common_click', {
        cms_id: this.pageId,
        event_name: this.eventName,
        module_name: this.hotzone.name,
        position: index,
        s_title: name
      })
    },

    getStyle(val) {
      return `${(((val || 0) * 10000) / 100).toFixed(2)}%;`
    }
  }
}
</script>

<style lang="less" scoped>
.hotzone-wrap {
  position: relative;
  margin-top: -2rpx;

  > img {
    display: block;
    width: 100%;
  }

  .area {
    position: absolute;
    background: rgba(255, 255, 200, 0);
  }
}
</style>
